import IconStar from '@/assets/icons/star.svg';
import Vue from 'vue';
import linkify from 'vue-linkify';
import { createNamespacedHelpers } from 'vuex';
import get from 'lodash/get';
import dayjs from 'dayjs';
import ChatDefs from '@/store/chat/chat.d';

Vue.directive('linkified', linkify);

const { mapState: mapUserState } = createNamespacedHelpers('User');
const { mapState: mapConciergeState } = createNamespacedHelpers('Concierge');
const { mapActions: mapChatActions } = createNamespacedHelpers('Chat');

export default {
  name: 'MessageItem',
  components: { IconStar },
  props: {
    id: String,
    text: String,
    type: String,
    url: String,
    item: Object,
    authorUserId: String,
    authorName: String,
    authorImage: String,
    timestamp: Number,
    isFromConcierge: Boolean,
    isAuthorImageVisible: Boolean,
    data: Object
  },
  data: function() {
    return {
      isDeleting: false,
      isDeleted: false
    };
  },
  computed: {
    ...mapUserState({
      lastActive: state => get(state, 'currentUser.lastActive', 0)
    }),

    ...mapConciergeState({
      currentConcierge: state => state.currentConcierge
    }),

    /**
     * There is a bug coming from S3 SDK on the app
     *  make the URL kinda incorrect, it affected old app
     *  hence we can only fix it on the concierge side
     */
    formattedUrl() {
      const malformedText = 'sgp1.digitaloceanspaces.com/tabiko/';
      return this.url && this.url.replace(malformedText, '');
    },

    /**
     * Flag indicator to determine if the user seen the message
     * We can get it by comparing with user's last active
     */
    isSeen: function() {
      if (!this.isFromConcierge) return false;
      const lastActive = dayjs(this.lastActive);
      const messageDatetime = dayjs(this.timestamp);
      return lastActive.diff(messageDatetime, 'minutes') > 0;
    },

    /**
     * Shorter name for retrieveing the nested data
     */
    richData: function() {
      return this.data.data;
    },

    /**
     * Used for the container style
     */
    messageContainerObject: function() {
      return {
        ['concierge-container']: this.isFromConcierge,
        ['user-container']: !this.isFromConcierge
      };
    },

    /**
     * Used for the bubble style
     */
    bubbleContainerObject: function() {
      return {
        ['concierge-bubble']: this.isFromConcierge,
        ['user-bubble']: !this.isFromConcierge
      };
    }
  },

  methods: {
    ...mapChatActions({
      chat_deleteMessage: ChatDefs.actions.deleteMessage
    }),

    deleteMessage: async function() {
      const isOk = confirm('Are you sure want to delete this message?');
      if (!isOk) return;

      this.isDeleting = true;
      // FIXME: direct object access like this is not a good idea.
      // Find a way to subscribe the data without access source object
      await this.chat_deleteMessage(this.item.messageId);
      this.isDeleted = true;
    }
  }
};
